import {VayvndFileUploadingApi} from '@frontend/api/VayvndFileUploadingApi'
import {WebCameraService} from '@frontend/services/WebCameraService'
import type {CrmUserFileType} from '@frontend/types/User'

// Информация о файле для API.
interface FileInfo {
    type: CrmUserFileType
    fileName: string
}

// Типы файлов для скрытой съемки.
type Types = 'signContract'

// Типы файлов.
const types: Record<Types, FileInfo> = {
    signContract: {
        type: 'sign_contract_photo',
        fileName: 'photo_new_request.png',
    },
}

// Фотографирует пользователя и отправляет фотографию на сервер.
export function sendHiddenPhoto(type: Types): Promise<Blob | null> {
    if (!(type in types)) {
        if (window.config?.env === 'local') {
            console.error('Invalid file type: ' + type)
        }
        return Promise.resolve(null)
    }
    const fileInfo: FileInfo = types[type]
    return new Promise(resolve => {
        WebCameraService.takeHiddenPhoto()
            .then(canvas => {
                canvas.toBlob((blob: Blob | null) => {
                    if (!blob) {
                        resolve(null)
                        return
                    }
                    VayvndFileUploadingApi
                        .uploadBlobFile(blob, fileInfo.type, 'webrtc', fileInfo.fileName)
                        .then(() => resolve(blob))
                        .catch(() => resolve(null))
                })
            })
            .catch(() => resolve(null))
    })
}
